import gql from "graphql-tag";

export const duplicateToProject = gql`
  mutation DuplicateToProject($input: DuplicateToProjectRequestInput) {
    DuplicateToProject(input: $input) {
      portId
    }
  }
`;
